import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArGrid, ArBullets, ArContactCTA } from "@/pages/ar/_ArShared";

export default function PdplAr() {
  return (
    <div data-testid="pdpl-ar">
      <Seo title="قانون حماية البيانات الشخصية في عُمان" description="القانون بإيجاز، ما تبنيه وفا داخل المنتج، والقرار الواعي بشأن مكان تخزين البيانات." />
      <ArPageHero
        eyebrow="حماية البيانات"
        h1="قانون حماية البيانات الشخصية في عُمان نافذ. هل برمجياتكم جاهزة؟"
        breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "الشركة", to: "/ar/company" }, { label: "قانون حماية البيانات" }]}
      />

      <ArBlock tint="white" heading="القانون بإيجاز">
        <div className="max-w-4xl space-y-5 text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          <p>صدر قانون حماية البيانات الشخصية في عُمان بموجب المرسوم السلطاني رقم 6/2022. ودخلت لائحته التنفيذية الصادرة بموجب القرار الوزاري رقم 34/2024 حيز التنفيذ الكامل اعتبارًا من 5 فبراير 2026، تحت إشراف وزارة النقل والاتصالات وتقنية المعلومات.</p>
          <p>المتطلبات:</p>
          <ArBullets items={[
            "موافقة صريحة وموثقة",
            "إشعارات خصوصية واضحة",
            "الرد على طلبات الأفراد خلال 45 يومًا دون مقابل",
            "تعيين مسؤول حماية بيانات ببيانات تواصل معلنة",
            "ضوابط على نقل البيانات خارج السلطنة، بما يشمل موافقة الوزارة على البيانات الشخصية الحساسة المعالجة خارج عُمان",
            "الإبلاغ عن أي خرق للوزارة خلال 72 ساعة إن كان يُعرّض حقوق الأفراد للخطر",
          ]} />
          <p>العقوبات بموجب القانون تصل إلى مبالغ كبيرة، وعدم الإبلاغ عن خرق يحمل غرامة منفصلة.</p>
        </div>
      </ArBlock>

      <ArBlock tint="cream" heading="أين تفشل معظم الأنظمة">
        <ArGrid columns={2} items={[
          { title: "الموافقة افتراض لا سجل", desc: "صندوق اختيار موجود، لكن لا سجل لما تمت الموافقة عليه، ومتى، وبأي نسخة من الإشعار." },
          { title: "لا توجد طريقة للرد على طلب", desc: "يطلب أحدهم نسخة من بياناته، ويستغرق الأمر ثلاثة أقسام وأسبوعين — بعد الموعد النهائي البالغ 45 يومًا." },
          { title: "الحذف لا يحذف فعليًا", desc: "تُعلَّم السجلات كغير نشطة وتبقى في قاعدة البيانات إلى الأبد، بما في ذلك النسخ الاحتياطية." },
          { title: "لا أحد يعرف إلى أين ذهبت البيانات", desc: "أداة تحليلات، مكتب مساعدة، منصة بريد إلكتروني — كل منها ينقل بيانات شخصية بهدوء إلى مكان ما، دون أي تقييم." },
        ]} />
      </ArBlock>

      <ArBlock tint="white" heading="ما نبنيه داخل المنتج">
        <ArBullets items={[
          "تسجيل الموافقة بسجل كامل لما تمت الموافقة عليه ومتى",
          "إدارة إشعارات الخصوصية بالعربية والإنجليزية مع تتبع النسخ",
          "مسار عمل لطلبات الأفراد يمكن إغلاقه خلال 45 يومًا",
          "سجلات معالجة تُحدَّث تلقائيًا مع تشغيل النظام",
          "كشف الخروقات وتصنيفها ومسار إبلاغ مبني لساعة الـ72",
          "صلاحيات وصول قائمة على الأدوار مع سجل تدقيق غير قابل للتعديل",
          "قواعد احتفاظ تحذف فعليًا، بما يشمل النسخ الاحتياطية",
        ]} />
      </ArBlock>

      <ArBlock tint="cream" heading="مكان بياناتكم قرار، لا صدفة">
        <p className="max-w-4xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          بموجب القانون، نقل البيانات الشخصية خارج السلطنة يستوجب: موافقة، وتقييمًا لمستوى الحماية في الدولة المستقبِلة، وموافقة الوزارة للبيانات الشخصية الحساسة. معظم الشركات لا تتخذ هذا القرار بوعي أبدًا — بل يرثنه من اختيار آخر مطوّر. نرسم ذلك معكم قبل البناء: ما البيانات التي تملكونها، أيها حساس، أين سيكون موقع كل مكوّن في النظام، وماذا يعني كل خيار بالنسبة لالتزاماتكم. ثم تقررون، عن وعي.
        </p>
      </ArBlock>

      <ArBlock tint="white" heading="خطوة أبعد مع Meyar">
        <p className="max-w-4xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
          تصميم نظام ملتزم هو النصف الأول. حوكمته لاحقًا هي النصف الثاني. تحتفظ Meyar بسجل مخاطركم، الضوابط، السياسات، عمليات التدقيق، الأدلة، وسجلات الخروقات، بمساعد ذكاء اصطناعي على كل بند من بنود المخاطر.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/ar/meyar" className="inline-flex items-center gap-1.5 rounded-md bg-wafa-deep px-5 py-2.5 text-sm font-semibold text-white hover:bg-wafa-primary">تعرّف على Meyar</Link>
          <Link to="/tools/pdpl-readiness-check" className="inline-flex items-center gap-1.5 rounded-md border border-wafa-deep/20 px-5 py-2.5 text-sm font-semibold text-wafa-deep hover:border-wafa-deep">تحقق من جاهزيتكم لقانون حماية البيانات</Link>
        </div>
      </ArBlock>

      <ArContactCTA heading="جاهزون؟ لنتحدث عن استعدادكم." />
    </div>
  );
}
